package navigation.home.travelagents

import navigation.home.travelagents.addedittravelagent.AddEditTravelAgentScreenModel
import navigation.home.travelagents.alltravelagents.AllTravelAgentsScreenModel
import org.koin.dsl.module

val travelAgentUiModule
    get() =
        module {

            factory {
                AllTravelAgentsScreenModel(
                    travelAgentRepository = get(),
                    loadingManager = get()
                )
            }

            factory {
                AddEditTravelAgentScreenModel(
                    travelAgentRepository = get(),
                    fileRepository = get(),
                    proposalRepository = get(),
                    itineraryRepository = get(),
                    toastManager = get(),
                    loadingManager = get()
                )
            }
        }
